"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiNode_1 = require("./ApiNode");
function Api(url, fetchFuncs, options) {
    var structure = (options || { structure: null }).structure;
    var apiProxy = {
        get: function (api, prop) {
            return prop in api ? api[prop] : new Proxy(node(api.$url, prop, api.$fetchFuncs, function (id) { return Api(concatUrl(concatUrl(api.$url, prop), id), fetchFuncs); }), apiProxy);
        }
    };
    return structure ?
        construct(url, fetchFuncs, structure, options) :
        new Proxy(ApiNode_1.apiNode(url, fetchFuncs, function (k) { return Api(concatUrl(url, k), fetchFuncs); }), apiProxy);
}
exports.Api = Api;
function node(url, key, optionsAndHeaders, id) {
    return ApiNode_1.apiNode(concatUrl(url, key), optionsAndHeaders, id);
}
function concatUrl(url, key) {
    return url + "/" + encodeURIComponent(key);
}
function construct(url, fetchFuncs, structure, apiOptions) {
    return Object.keys(structure).reduce(function (api, k) {
        var _a;
        var nodeObj = node(url, k, fetchFuncs, function (id) { return Api(concatUrl(concatUrl(url, k), id), fetchFuncs, { structure: structure[k].$id }); });
        var isLeaf = typeof structure[k] === "boolean";
        var nodeWithKids = isLeaf ? nodeObj : Object.assign(nodeObj, construct(concatUrl(url, k), fetchFuncs, structure[k], apiOptions));
        return __assign({}, api, (_a = {}, _a[k] = nodeWithKids, _a));
    }, {});
}
//# sourceMappingURL=index.js.map